"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const axios_1 = __importDefault(require("axios"));
const AbcNotValidError_1 = __importDefault(require("../../domain/errors/AbcNotValidError"));
const dayjs_1 = __importDefault(require("../../../shared/lib/dayjs"));
function abcRepository() {
    return { findByCriteria, findDealerBySubsidiary, getAllInsurers };
}
exports.default = abcRepository;
async function findByCriteria(price, plazo, enganche) {
    const request = {
        enganche: enganche,
        plan_term: plazo,
        price: price,
    };
    const { data } = await axios_1.default.post(`/abc/calcular-cotizacion`, request);
    if (!data.succes || !data.data.success) {
        throw new AbcNotValidError_1.default("Algo salio mal");
    }
    return {
        data: data.data.items[`P${plazo}`],
        quotation: data.quotation,
        succes: data.succes,
    };
}
async function getAllInsurers(months, price, year, eikosId, slug) {
    const params = new URLSearchParams({
        term: String(months),
        hyundaiKey: String(eikosId),
        year: String(year),
        vehiclePrice: String(price),
        slug: slug ?? "",
    });
    const { data } = await axios_1.default.get(`/simulator/v1/abc/insurers?${params.toString()}`);
    const transformDates = (item) => {
        item.PRIMA_TOTAL = +item.PRIMA_TOTAL;
        item.ID_COTIZACION = +item.ID_COTIZACION;
        item.VIGENCIA_INI = (0, dayjs_1.default)(item.VIGENCIA_INI, "DD/MM/YYYY").toDate();
        item.VIGENCIA_FIN = (0, dayjs_1.default)(item.VIGENCIA_FIN, "DD/MM/YYYY").toDate();
        item.MULTIRECIBOS?.forEach((receipt) => {
            receipt.PRIMA_TOTAL = +receipt.PRIMA_TOTAL;
            receipt.NUMERO = +receipt.NUMERO;
            receipt.VIGENCIA_INI = (0, dayjs_1.default)(receipt.VIGENCIA_INI, "DD/MM/YYYY").toDate();
            receipt.VIGENCIA_FIN = (0, dayjs_1.default)(receipt.VIGENCIA_FIN, "DD/MM/YYYY").toDate();
        });
        item.RECIBOS?.forEach((receipt) => {
            receipt.PRIMA_TOTAL = +receipt.PRIMA_TOTAL;
            receipt.NUMERO = +receipt.NUMERO;
            receipt.VIGENCIA_INI = (0, dayjs_1.default)(receipt.VIGENCIA_INI, "DD/MM/YYYY").toDate();
            receipt.VIGENCIA_FIN = (0, dayjs_1.default)(receipt.VIGENCIA_FIN, "DD/MM/YYYY").toDate();
        });
    };
    data.COMPLETE.forEach(transformDates);
    data.TOTAL.forEach(transformDates);
    return [...data.COMPLETE, ...data.TOTAL];
}
async function findDealerBySubsidiary(subsidiary) {
    const { data } = await axios_1.default.get(`/abc/dealerInfoByCaption/${subsidiary}`);
    return {
        address: data.sub_address,
        name: data.sub_name,
        phone: data.sub_phones,
    };
}
